import React from "react";
import GameOver from "assets/images/flus/game-over.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants,
  fadeVariants
} from "shared/components/animations";
import _ from "lodash";

const FLUSOver = () => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="game-over"
    >
      <motion.img
        variants={staticBounceVariants}
        src={GameOver}
        className="game-over-btn"
        alt=""
      />
      <motion.p variants={fadeVariants} className="text">
        Hope you got to know each other better.
      </motion.p>
    </motion.div>
  );
};

export default FLUSOver;
